// src/chat/jalali.js
// تبدیل میلادی به شمسی و ارقام فارسی — بدون کتابخانه خارجی

export function toFa(s) {
  const fa = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
  return String(s).replace(/\d/g, d => fa[d]);
}

function gregorianToJalali(gy, gm, gd) {
  const g_d_m = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334];
  const gy2 = gy - 1600;
  const gm2 = gm - 1;
  const gd2 = gd - 1;
  let g_day_no = 365 * gy2 + Math.floor((gy2 + 3) / 4)
    - Math.floor((gy2 + 99) / 100) + Math.floor((gy2 + 399) / 400);
  g_day_no += g_d_m[gm2] + gd2;
  if (gm2 > 1 && ((gy % 4 === 0 && gy % 100 !== 0) || gy % 400 === 0)) g_day_no += 1;
  let j_day_no = g_day_no - 79;
  const j_np = Math.floor(j_day_no / 12053);
  j_day_no %= 12053;
  let jy = 979 + 33 * j_np + 4 * Math.floor(j_day_no / 1461);
  j_day_no %= 1461;
  if (j_day_no >= 366) {
    jy += Math.floor((j_day_no - 1) / 365);
    j_day_no = (j_day_no - 1) % 365;
  }
  const j_days = [31, 31, 31, 31, 31, 31, 30, 30, 30, 30, 30, 29];
  let jm = 0;
  while (jm < 11 && j_day_no >= j_days[jm]) { j_day_no -= j_days[jm]; jm += 1; }
  return [jy, jm + 1, j_day_no + 1];
}

// ورودی: رشته‌ی ISO تاریخ از سرور → خروجی: «۱۴۰۴/۰۱/۰۱ - ۱۴:۳۲»
export function formatJalali(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  if (isNaN(d.getTime())) return '';
  const [jy, jm, jd] = gregorianToJalali(d.getFullYear(), d.getMonth() + 1, d.getDate());
  const pad = n => String(n).padStart(2, '0');
  const datePart = `${jy}/${pad(jm)}/${pad(jd)}`;
  const timePart = `${pad(d.getHours())}:${pad(d.getMinutes())}`;
  return toFa(`${datePart} - ${timePart}`);
}
